import { render, staticRenderFns } from "./PostText.vue?vue&type=template&id=4b13364e&scoped=true&"
import script from "./PostText.vue?vue&type=script&lang=js&"
export * from "./PostText.vue?vue&type=script&lang=js&"
import style0 from "./PostText.vue?vue&type=style&index=0&id=4b13364e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b13364e",
  null
  
)

export default component.exports